import { useState } from "react";
import { post } from "../networking/RequestService";
import { apiErrorText } from "app/popleads/networking/apiErrorText";

function useSetUserSettings({ onSuccess, onError } = {}) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const setUserSettings = async (params = {}) => {
        setLoading(true);
        setError(null);

        const { settingsKey, settingsValue } = params;

        if (!settingsKey || !settingsValue) {
            const errorMessage = "Missing required parameters";
            setError(errorMessage);
            if (typeof onError === "function") {
                onError(errorMessage);
            }
            setLoading(false);
            return { error: errorMessage };
        }

        try {
            const response = await post({ fn: "setUserSettings", ...params });
            if (typeof onSuccess === "function") {
                onSuccess(response.data);
            }
            return { data: response.data };
        } catch (error) {
            const errorMessage = apiErrorText(error);
            setError(errorMessage);
            if (typeof onError === "function") {
                onError(errorMessage);
            }
            return { error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { setUserSettings, loading, error };
}

export default useSetUserSettings;
